"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TcPropertiesDtoBiradsEnum = exports.TcPropertiesDtoBreastDensityAssessmentTypeEnum = exports.TcPropertiesDtoHrtTypeEnum = exports.TcPropertiesDtoHrtWhenEnum = exports.TcPropertiesDtoBrca2TestResultEnum = exports.TcPropertiesDtoBrca1TestResultEnum = exports.TcPropertiesDtoMenopausalStatusEnum = void 0;
exports.TcPropertiesDtoMenopausalStatusEnum = {
    PreMenopausal: 'PreMenopausal',
    PeriMenopausal: 'PeriMenopausal',
    PostMenopausal: 'PostMenopausal',
    Menopausal: 'Menopausal'
};
exports.TcPropertiesDtoBrca1TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
exports.TcPropertiesDtoBrca2TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
exports.TcPropertiesDtoHrtWhenEnum = {
    PreviousLessThanFive: 'PreviousLessThanFive',
    PreviousGreaterThanEqualFive: 'PreviousGreaterThanEqualFive',
    Current: 'Current',
    Unknown: 'Unknown'
};
exports.TcPropertiesDtoHrtTypeEnum = {
    Estrogen: 'Estrogen',
    Combined: 'Combined'
};
exports.TcPropertiesDtoBreastDensityAssessmentTypeEnum = {
    Birads: 'Birads',
    Vas: 'Vas',
    Volpara: 'Volpara'
};
exports.TcPropertiesDtoBiradsEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D'
};
